import { useEffect, useState } from "react";


import MediaPreview from "./MediaPreview";
import MediaInfo from "./MediaInfo";
import MediaListsSection from "./MediaListsSection";
import MediaActionButtons from "./MediaActionButtons";
import useToast from "../common/toast/useToast";
import useMedia from "../../hooks/useMedia";

export default function MediaDetailsDrawer({

    open,

    mediaId,
toggle,isSelected,selected,
    onClose,

    onRename,

    onMove,
    refreshLists,
    loadingLists,
    setAddOpen,
    setEditingMedia,
    setRenameOpen,
    setSelected,
    setMoveOpen,
    openBulkDelete,
    onRemove,
    onAdd,

    onDelete

}) {

    const {

        loadMediaById

    } = useMedia();

    const [

        loading,

        setLoading

    ] = useState(false);

    const [

        media,

        setMedia

    ] = useState(null);
 const toast =useToast()

const  refreshMedia=()=>{
    (async () => {

            try {

                setLoading(true);

                const data =
                    await loadMediaById(mediaId);

                setMedia(data);
               
            }

            finally {

                setLoading(false);

            }

        })();
 }
    useEffect(() => {

        if (

            !open ||

            !mediaId

        ) {

            return;

        }

        refreshMedia()

    }, [

        open,

        mediaId,loadingLists

    ]);

    if (!open) {

        return null;

    }

    return (

        <>

            <div

                className="media-drawer-backdrop"

                onClick={onClose}

            />

            <aside className="media-drawer">

                <div className="drawer-header">

                    <span>

                        Media Details

                    </span>

                    <button

                        onClick={onClose}

                    >

                        ✕

                    </button>

                </div>

                {

                    loading

                    ?

                    <div className="drawer-loading">

                        Loading...

                    </div>

                    :

                    media &&

                    <div className="drawer-body">

                        <MediaPreview

                            media={media}

                        />

                      
<div className="drawer-selection">

    <button

        className={`drawer-select-btn ${
            isSelected(media.id)
                ? "selected"
                : ""
        }`}

        onClick={() => toggle(media.id)}

    >

        {

            isSelected(media.id)

                ? "✓ Selected"

                : "+ Select"

        }

    </button>

</div>{
          isSelected(media.id)
            ?<>
                        <MediaListsSection

                        refreshLists={refreshLists}

    media={media}

    onAdd={() =>

        setAddOpen(true)

    }

    onRemove={(id,mediaid)=>onRemove(id,mediaid)}

/>

                     <MediaActionButtons

    media={media}

    onRename={media=>{

        setEditingMedia(media);

        setRenameOpen(true);

    }}

    onMove={media=>{

        setSelected([media.id]);

        setMoveOpen(true);

    }}

    onAdd={media=>{

        setSelected([media.id]);

        setAddOpen(true);

    }}

    onDelete={media=>{

        openBulkDelete([media.id]);

    }}

/></>
:""}
          <MediaInfo

                            media={media}

                        />            </div>

                }

            </aside>

<style>{`

.media-drawer-backdrop{

    position:fixed;

    inset:0;

    background:rgba(0,0,0,.25);

    z-index:9998;

}

.media-drawer{

    position:fixed;

    top:0;

    right:0;
 width:min(440px,100vw);

    height:100vh;

    background:#FFF;

    display:flex;

    flex-direction:column;

    box-shadow:

        -8px 0 40px rgba(0,0,0,.18);

    z-index:9999;

    animation:slideDrawer .25s ease;

}

.drawer-header{

    height:64px;

    display:flex;

    align-items:center;

    justify-content:space-between;

    padding:0 20px;

    border-bottom:1px solid #E5E7EB;

    font-size:18px;

    font-weight:600;

}

.drawer-header button{

    width:34px;

    height:34px;

    border:none;

    border-radius:8px;

    background:#F3F4F6;

    cursor:pointer;

}

.drawer-header button:hover{

    background:#E5E7EB;

}

.drawer-body{

    flex:1;

    overflow:auto;overflow-x:hidden;

    padding:22px;

    display:flex;

    flex-direction:column;

    gap:22px;

}

.drawer-loading{

    display:flex;

    justify-content:center;

    align-items:center;

    flex:1;

    color:#64748B;

}

@keyframes slideDrawer{

    from{

        transform:translateX(100%);

    }

    to{

        transform:translateX(0);

    }

}
  .drawer-selection{

    display:flex;

    justify-content:flex-end;

}

.drawer-select-btn{

    height:38px;

    padding:0 16px;

    border:1px solid #D7DCE3;

    border-radius:10px;

    background:#FFFFFF;

    color:#374151;

    font-size:14px;

    font-weight:600;

    cursor:pointer;

    transition:.2s;

}

.drawer-select-btn:hover{

    border-color:rgba(144,202,249,1);

    background:#F8FBFF;

}

.drawer-select-btn.selected{

    background:rgba(144,202,249,.15);

    border-color:rgba(144,202,249,1);

    color:#1565C0;

}
    
@media(max-width:640px){

.media-drawer{

    width:100vw;

}

}

`}</style>

        </>

    );

}